import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';

const Swapper = ({
  type,
  height = '2rem',
  to,
  target,
  state,
  initial,
  animate,
  exit,
  transition,
  onClick,
  className,
  children,
  swapChildren,
}) => {
  if (type === 'button' || type === 'submit') {
    return (
      <SwapButton
        as='button'
        $height={height}
        className={className}
        initial={initial}
        animate={animate}
        exit={exit}
        transition={transition}
        onClick={onClick}
      >
        <SwapChild $height={height}>{children}</SwapChild>
        <SwapChild $height={height}>{swapChildren ? swapChildren : children}</SwapChild>
      </SwapButton>
    );
  } else if (type === 'Link') {
    return (
      <SwapButton
        as={motion(Link)}
        to={to}
        state={state}
        target={target}
        $height={height}
        className={className}
        initial={initial}
        animate={animate}
        exit={exit}
        transition={transition}
        onClick={onClick}
      >
        <SwapChild $height={height}>{children}</SwapChild>
        <SwapChild $height={height}>{swapChildren ? swapChildren : children}</SwapChild>
      </SwapButton>
    );
  } else {
    return (
      <SwapWrapper
        $height={height}
        className={className}
        initial={initial}
        animate={animate}
        exit={exit}
        transition={transition}
        onClick={onClick}
      >
        <SwapChild $height={height}>{children}</SwapChild>
        <SwapChild $height={height}>{swapChildren ? swapChildren : children}</SwapChild>
      </SwapWrapper>
    );
  }
};

export const SwapChild = styled.span`
  height: ${props => props.$height};
  min-height: ${props => props.$height};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceSm};
  transition: margin ${props => props.theme.transition};
`;

export const SwapWrapper = styled(motion.div)`
  height: ${props => props.$height};
  min-height: ${props => props.$height};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: ${props => {
    return ['scale', 'background-color', 'border-color', 'color', 'box-shadow']
      .map(style => `${style} ${props.theme.transition}`)
      .join(',');
  }};

  &:hover {
    ${SwapChild}:first-of-type {
      margin-top: calc(-1 * ${props => props.$height});
    }
  }
`;

export const SwapButton = styled(SwapWrapper)`
  text-transform: uppercase;
  font-weight: ${props => props.theme.headerWeight};
  letter-spacing: ${props => props.theme.headerSpacing};
  border-radius: ${props => props.theme.borderFull};
`;

export default Swapper;
